import React, { Fragment, useRef } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import FacebookAdsCalculator from "../tools/facebookAdsCalculator/FacebookAdsCalculator";
import AccessForm from "./AccessForm";
import { useAuth, useLanguage } from "../context/LanguageContext";

const ProjectContainer = () => {
  // const isAuth = useAuth();
  const currentLanguage = useLanguage();
  const notSupported = useRef();

  // Delete the 2 lines below when it's time to use the auth log again and uncomment line above
  let isAuth = [];
  isAuth[3] = "auth";

  return (
    <Fragment>
      <Router>
        <div className="project">
          <div ref={notSupported} className="not-supported">
            {currentLanguage.notSupported}{" "}
            <div
              className="not-supported__close"
              onClick={() => (notSupported.current.style.display = "none")}>
              {currentLanguage.close}
            </div>
          </div>
          {isAuth[3] === "auth" ? (
            <Switch>
              <Route exact path="/" component={FacebookAdsCalculator} />
            </Switch>
          ) : (
            <AccessForm />
          )}
        </div>
      </Router>
    </Fragment>
  );
};

export default ProjectContainer;
